import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseHead = async (houseId) => {
  return await request.get(
    `/HousingStock/house/${houseId}/head`,
    {},
    'При загрузке старшего по дому произошла ошибка',
    {}
  );
};

const useHouseHead = (houseId, options = {}) =>
  useQuery(getQueryKeys.houseHead(houseId), () => getHouseHead(houseId), {
    placeholderData: {},
    enabled: Boolean(houseId),
    ...options,
  });

export default useHouseHead;
